import settings from '../config/config.json'

export default {
	install: (Vue) => {
		Vue.prototype.$getSettings = function (key) {
			return settings[key];
		}
	}
};
